import { SvgBuildingLock } from '@cocoonspace/icons/react/font-awesome/light/building-lock'
import type { Event } from '@cocoonspace/sdk-js/types/event'
import { useTranslation } from 'next-i18next'
import type { ComponentProps } from 'react'

import { cn } from '~/lib/utils'

export const EventAccessDoorCode = ({
	event,
	...props
}: {
	event: Pick<Event, 'access'>
} & ComponentProps<'div'>) => {
	const { t } = useTranslation()

	return (
		<div
			className={cn(
				'flex flex-row items-center gap-2 text-sm',
				props.className,
			)}
		>
			<div>
				<SvgBuildingLock
					width={26}
					height={26}
				/>
			</div>

			<div
				className={
					event.access?.door_code ? 'text-4xl text-primary' : 'text-sm'
				}
			>
				{event.access?.door_code || t('cwEvents:accessDoorCode')}
			</div>
		</div>
	)
}
